<template>
  <div>
    <div class="tableheader header">
      <img :src="back" alt="" @click="$router.go(-1)">
      <span>数据看板</span>
      <span></span>
    </div>
    <MobileStreamTable
      :rows="rows"
      :auto-interval="30"
      @filter="onFilter"
      @tick="fetchRealtime"
    >
    <div>
      浏览量：{{ viewCount }}
      观看人数：{{ userCount }}
    </div>
    </MobileStreamTable>
  </div>
</template>

<script>
import MobileStreamTable from '@/components/MobileStreamTable.vue'
import { getLiveData } from '@/api'
import { formatTime } from '@/utils/common'
import back from '@/assets/arrow-left.svg'
import { jsonp } from '@/utils/jsonp';

// 按房间聚合
async function fetchRoomStats() {
  const res = await fetch('https://streamer.wokfoy.com/stats/room', { credentials: 'omit' });
  return res.json(); // [{room_id:"xxx", visits: 12, avg_duration: 8423.3, ok_count: 9}, ...]
}

// 按天聚合（可带 day=YYYY-MM-DD）
async function fetchDailyStats(day) {
  const url = day ? `https://streamer.wokfoy.com/stats/daily?day=${encodeURIComponent(day)}` 
                  : 'https://streamer.wokfoy.com/stats/daily';
  const res = await fetch(url, { credentials: 'omit' });
  return res.json(); // { visits: 123, merged: 110, avg_dur: 7132.5 }
}
export default {
  components: { MobileStreamTable },
  data() {
    return {
      rows: [],
      back:back,
      viewCount:0,
      userCount:0,
    }
  },
  async mounted(){
    loadLiveRows()
  },  
  methods: {
    async onFilter(payload) {
      // payload: { mode: 'realtime'|'range', start, end }
      // 调接口拉取数据并赋值到 this.rows
      let end_time
      if(!payload.end_time){
        end_time = formatTime(new Date(payload.start_time).getTime() + (24 * 60 * 60 * 1000))
      }
      console.log(payload.stream_name,payload.start_time,end_time)

      let { data } = await getLiveData(
        payload.stream_name,
        payload.start_time,
        payload.end_time || end_time
      )
      this.rows = Object.entries(data.user_count_statics.user_statistics) || []
      this.viewCount = data.user_count_statics?.in_room_allin_count || 0
      this.userCount = data.user_count_statics?.in_room_user_count || 0
    },
    async fetchRealtime({stream_name,start_time}) {
      // 实时模式轮询触发：调接口刷新 this.rows
      let end_time = formatTime(new Date(start_time).getTime() + (24 * 60 * 60 * 1000))
      let { data } = await getLiveData(
        stream_name,
        start_time,
        end_time
      )
      this.rows = Object.entries(data.user_count_statics.user_statistics) || []
      this.viewCount = data.user_count_statics?.in_room_allin_count || 0
      this.userCount = data.user_count_statics?.in_room_user_count || 0
    }
  }
}
</script>
<style>
.tableheader{
  display: flex;
  height: 50px;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}
.tableheader img{
  width: 25px;
  height: 25px;
}
</style>